import type { BadgeDotProp } from "../Badge/Badge.types";
import type { AvatarProps } from "./Avatar.types";

export const useAvatarSize = (size: AvatarProps<"div">["size"]) => {
  switch (size) {
    case "xsmall":
      return "24px";

    case "small":
      return "32px";

    case "large":
      return "48px";

    case "xlarge":
      return "64px";

    case "2xlarge":
      return "96px";

    case "3xlarge":
      return "120px";

    default:
      return "40px";
  }
};

export const useAvatarDotSize = (
  size: AvatarProps<"div">["size"],
): {
  dotSize: BadgeDotProp["size"];
  offset: string;
} => {
  switch (size) {
    case "large":
    case "xlarge":
    case "2xlarge":
    case "3xlarge":
      return {
        dotSize: "large",
        offset: "2px",
      };

    case "small":
    case "xsmall":
      return {
        dotSize: "medium",
        offset: "0px",
      };

    default:
      return {
        dotSize: "largeBold",
        offset: "0px",
      };
  }
};

export const useAvatarDotNumberSize = (
  size: AvatarProps<"div">["size"],
): {
  offset: string;
} => {
  switch (size) {
    case "large":
    case "xlarge":
    case "2xlarge":
    case "3xlarge":
      // -7px
      return {
        offset: "7px",
      };

    case "small":
    case "xsmall":
      return {
        offset: "4px",
      };

    default:
      return {
        offset: "5px",
      };
  }
};
